(() => {
	angular.module('main').directive('modalSendMail', modalSendMail);

	modalSendMail.$inject = [
		'$http',
		'$rootScope',
		'$q',
		'$route',
		'$location',
		'messageService',
		'jobDataService',
		'fileUploadService',
		'fileUploadDataService',
		'validationService',
		'templateRequestsService',
		'emailService',
		'workflowDataService',
		'jobTypesDataService',
		'newJobsDataService',
		'workflowService',
		'utilsService',
		'stringModifierService',
		'mailsDataService'
	];

	function modalSendMail(
		$http,
		$rootScope,
		$q,
		$route,
		$location,
		messageService,
		jobDataService,
		fileUploadService,
		fileUploadDataService,
		validationService,
		templateRequestsService,
		emailService,
		workflowDataService,
		jobTypesDataService,
		newJobsDataService,
		workflowService,
		utilsService,
		stringModifierService,
		mailsDataService
	) {
		return {
			restrict: 'E',
			scope: {
				mailData: '<snMailData',
				isClientsOverview: '=snHideLink',
				customToken: '=snCustomToken',
				mailDataClient: '<',
				onCcResubscribe: '&',
				updateParent: '&?',
				mainShootLabelName: '=',
				extraShootLabelName: '=',
				businessNumberLabelName: '='
			},
			template() {
				const templateHtml = `
                <div id="main-wrapper" class="container">
                    <div id="sendContactEmailModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">
                        <div class="modal-dialog">
                            <form class="modal-content form-horizontal" role="form" autocomplete="off"
                                  ng-submit="mailDataClient.status===undefined ? sendUserEmail() : sendUserEmailReply()">
                                <div class="modal-header">
                                    <btn-close ng-click="modalClose()"></btn-close>
                                    <h3 class="modal-title">Send Email</h3> </div>
                                <div class="modal-body">
                                    <p ng-show="isClientsOverview && !isClientProfile" class="send-mail-description">Note: if you would like to send your client a quote, invoice, contract or questionnaire please
                                        <a class="add-job-link color-java" href="javascript:void(0);" ng-click="addNewJob($event)">add a new job</a>
                                       for this client first. All quotes, invoices, contracts and questionnaires are managed from within the job profile page.</p>
                                    <div class="field-info">
                                       <h4 class="mt-0">To</h4>

                                        <div class="flex-row">
											<email-field class="w-max-100"
														ng-if="mailDataClient.status === undefined"
														[disabled]="mailData.isDisable"
														[placeholder]="'myclient@abc.com'"
														[value]="sendMessageData.emailTo"
														(value-change)="setEmailData($event, 'sendMessageData', 'emailTo')">
											</email-field>

											<email-field class="w-max-100"
														ng-if="mailDataClient.status === null"
														[value]="mailDataClient.from"
														[placeholder]="'myclient@abc.com'"
														(value-change)="setEmailData($event, 'mailDataClient', 'from')">
											</email-field>

											<button type="button" class="btn btn-link color-cc" ng-show="!showCcField && !mailData.isDisable" ng-click="toggleViewCc()">Add Cc </button>
                                        </div>
                                    </div>
                                    <div class="field-info" ng-show="showCcField && mailDataClient.status===undefined">
                                        <h4>Cc</h4>
                                         <email-field [value]="sendMessageData.emailCc"
                                         			  [placeholder]="'another@email.com'"
                                         			  (value-change)="setEmailData($event, 'sendMessageData', 'emailCc')">
										</email-field>
                                    </div>

                                    <div class="field-info" ng-show="showCcField && mailDataClient.status===null">
                                        <h4>Cc</h4>
                                        <email-field [value]="mailDataClient.emailCc"
                                        			 [placeholder]="'another@email.com'"
                                        			 (value-change)="setEmailData($event, 'mailDataClient', 'emailCc')">
										</email-field>
                                    </div>
                                    <div class="field-info">

                                        <h4>Email template</h4>
                                        <div class="flex-row" ng-if="mailDataClient.status === undefined">
                                            <div class="select-style flex-grow-1">
                                                <select
                                                 	ng-model="$parent.selectedEmailTemplate"
                                                 	ng-change="changEmail(selectedEmailTemplate)"
                                                  	ng-disabled = "!emailTemplates.length || button_disable"
                                               		ng-options="template as template.name for template in emailTemplates | orderBy track by template.name">
                                                    <option value="">Choose an existing email template</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="flex-row" ng-if="mailDataClient.status === null">
                                            <div class="select-style flex-grow-1">
                                                <select ng-model="mailDataClient.choosenEmail" ng-change="changEmailClient()" ng-disabled="button_disable" ng-options="item as item.name for item in mailDataClient.emails | orderBy">
                                                    <option value="">Choose an existing email template</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="subject-row mt-20">
                                    	<insert-variable ng-if="customToken" class="insert-variable" [variable-list-type]="customToken + '_SUBJECT'" (on-variable-choose)="addSubjectVariable($event, 'subject-send-mail')"></insert-variable>
                                    	<sn-input-text sn-title="Subject" sn-id="subject-send-mail" sn-model="sendMessageData.emailSubject" sn-placeholder="Write an awesome subject line. Why not?" ng-if="mailDataClient.status===undefined"></sn-input-text>
                                    	<sn-input-text sn-title="Subject" sn-id="subject-send-mail" sn-model="mailDataClient.emailSubject" sn-placeholder="Write an awesome subject line. Why not?" ng-if="mailDataClient.status === null"></sn-input-text>
                                    </div>

                                    <div class="field-info" ng-if="customToken" ng-class="{'clients-overview-page': isClientsOverview}">
                                        <h4>Message</h4>
                                        <sn-quill-editor-web
																					ng-if="clientToken || isClientsOverview"
																					[editor-i-d]="'send_message_text1'"
																					[init-value]="mailDataClient.status === undefined ? sendMessageData.emailText : mailDataClient.emailText"
																					[toolbar-settings]="'variables attachments color size font'"
																					[vars-list]="customToken"
																					[files-obj]="tokenAttachmentsData"
																					(on-text-change)="mailDataClient.status === undefined ? (sendMessageData.emailText = $event) : (mailDataClient.emailText = $event)">
																				</sn-quill-editor-web>

																				<sn-quill-editor-web
																					ng-if="!clientToken && !isClientsOverview"
																					[editor-i-d]="'send_message_text2'"
																					[init-value]="mailDataClient.status === undefined ? sendMessageData.emailText : mailDataClient.emailText"
																					[vars-list]="customToken"
																					[toolbar-settings]="'variables attachments color size font'"
																					[files-obj]="attachmentsData"
																					(on-text-change)="mailDataClient.status === undefined ? (sendMessageData.emailText = $event) : (mailDataClient.emailText = $event)">
																				</sn-quill-editor-web>
                                     </div>
                                </div>
                                <div class="modal-footer modal-foot">
                                    <button type="submit" class="btn btn-success btn-lg" ng-disabled="disableBtnOnSend" spinning-wheel is-spinning-wheel-active="disableBtnOnSend">Send Email </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>`;

				return templateHtml;
			},
			link(scope, element, attrs) {
				scope.isClientProfile = $location.path().includes('clients/');
				scope.isLeadPage = $location.path().includes('leads/');
				scope.isJobPage = $location.path().includes('jobs/');

				scope.clientEmails = [];
				scope.emailTemplates = [];
				scope.reminderrr = ['JOB_MENU'];
				scope.sendMessageData = {};
				scope.emailDataToSave = {};
				scope.mailDataClient = {};
				scope.emailDataToSaveReply = {};
				scope.uploadedAttachments = [];
				scope.variableSet = 'CLIENT_MENU';

				let isFirstShow = true;
				const EMPTY_ATTACHMENTS_OBJECT = {
					attachments: [],
					filesSize: 0
				};

				let attachmentsObj = JSON.parse(
					JSON.stringify(EMPTY_ATTACHMENTS_OBJECT)
				);

				delete scope.sendMessage;

				scope.$watch(attrs.snCustomToken, token => {
					scope.customToken = token;
				});

				scope.$watch('mailData', newValue => {
					if (newValue) {
						setMailData(newValue);
					}
				});

				scope.$watch('showCcField', () => {
					scope.$evalAsync();
				});

				function clearAttachments() {
					scope.attachmentsData = JSON.parse(
						JSON.stringify(EMPTY_ATTACHMENTS_OBJECT)
					);
				}

				scope.attachmentsData = angular.copy(attachmentsObj);
				scope.tokenAttachmentsData = angular.copy(attachmentsObj);

				function prepareEmailTemplate(mailData) {
					const email = angular.copy(mailData.task.taskEmail);
					if (email.name) {
						email.name = stringModifierService.addSelectedText(email.name);
					}
					scope.emailTemplates.push(email);
					scope.selectedEmailTemplate = email;
				}

				scope.modalClose = function() {
					delete scope.uploadedAttachments;
					delete scope.attachmentsData;
					delete scope.emailTemplates;
					delete scope.selectedEmailTemplate;
					fileUploadDataService.setCheckedFiles(null);
					if (scope.mailData.task !== undefined) {
						if (scope.isLeadPage) {
							$rootScope.updateLeadView();
						} else if (scope.isJobPage) {
							$rootScope.updateJobView();
						}
					}

					scope.showCcField = false;

					isFirstShow = true;
				};

				scope.$watchCollection('attachmentsData', (newValue, oldValue) => {
					if (
						newValue &&
						newValue !== oldValue &&
						newValue.attachments.length &&
						newValue.attachments.length !== 0 &&
						scope.isUserEmail
					) {
						addUploadedAttachments(newValue);
					}
				});

				scope.addSubjectVariable = function($event, id) {
					const el = document.getElementById(id);
					const subject = emailService.addSubjectVariable(el, $event);
					if (scope.mailDataClient.status === undefined) {
						scope.sendMessageData.emailSubject = subject;
					}

					if (scope.mailDataClient.status === null) {
						scope.mailDataClient.emailSubject = subject;
					}
				};

				function addUploadedAttachments(attachmentsData) {
					const { attachments } = attachmentsData;
					scope.uploadedAttachments = [];
					angular.forEach(attachments, attachment => {
						if (!attachment.id) {
							scope.uploadedAttachments.push(attachment);
						} else if (attachment.hasOwnProperty('checked')) {
							const copiedAttachment = angular.copy(attachment);
							scope.uploadedAttachments.push(copiedAttachment);
						}
					});
				}

				const isUserEmail = email =>
					!email.hasOwnProperty('emailTemplateType') &&
					!email.hasOwnProperty('defaultEmailTemplate');

				// Call this fn for errors
				function setEmptyEmailData() {
					scope.selectedEmailTemplate = null;
					scope.sendMessageData.emailSubject = '';
					scope.sendMessageData.emailText = '';
					if (scope.mailData.mailSignature) {
						scope.sendMessageData.emailText += `<br><br>${
							scope.mailData.mailSignature
						}`;
					}
					scope.attachmentsData = angular.copy(attachmentsObj);
					scope.tokenAttachmentsData = angular.copy(attachmentsObj);
				}

				scope.changEmail = email => {
					if (email === null || email === undefined) {
						setEmptyEmailData();
					} else if (email && typeof email === 'object') {
						const isUserEmailChosen = isUserEmail(email);
						scope.isUserEmail = isUserEmail(email);

						if (isUserEmailChosen) {
							scope.selectedEmailTemplate = email;
							scope.sendMessageData.emailSubject = email.subject || '';
							scope.sendMessageData.emailText = email.text || '';

							const attachments = angular.copy(email.storedAttachments) || [];
							if (
								attachments.length ||
								(scope.uploadedAttachments && scope.uploadedAttachments.length)
							) {
								const storedAttachments = angular.copy(email.storedAttachments);
								const allAttachments =
									storedAttachments !== null
										? angular.copy(email.storedAttachments)
										: [];

								if (
									scope.uploadedAttachments &&
									scope.uploadedAttachments.length
								) {
									angular.forEach(scope.uploadedAttachments, attachment => {
										allAttachments.push(attachment);
									});
								}

								scope.attachmentsData = {
									attachments: allAttachments
								};
							} else {
								clearAttachments();
							}
						} else if (email.id) {
							templateRequestsService
								.getTemplates('full_template', email.id)
								.subscribe(emailTemplate =>
									successSetEmailTemplate(emailTemplate)
								);
						}
					} else {
						console.error('no chosen email');
					}
				};

				function successSetEmailTemplate(emailTemplate) {
					if (
						emailTemplate.storedAttachments &&
						emailTemplate.storedAttachments.length
					) {
						scope.attachmentsData = {
							attachments: fileUploadService.convertAttachmentsToShow(
								emailTemplate.storedAttachments
							)
						};
						scope.tokenAttachmentsData = angular.copy(scope.attachmentsData);
						scope.$evalAsync();
					} else {
						scope.attachmentsData = angular.copy(attachmentsObj);
						scope.tokenAttachmentsData = angular.copy(attachmentsObj);
					}
					scope.sendMessageData.emailSubject = emailTemplate.subject || '';
					scope.sendMessageData.emailText = emailTemplate.text || '';
					scope.$evalAsync();
				}

				scope.toggleViewCc = function(state) {
					scope.showCcField = state === undefined ? !scope.showCcField : state;
					if (state === false) {
						attachmentsObj = {
							attachments: [],
							filesSize: 0
						};

						scope.attachmentsData = angular.copy(attachmentsObj);
						scope.tokenAttachmentsData = angular.copy(attachmentsObj);
					}
				};

				scope.changEmailClient = () => {
					if (
						!scope.mailDataClient.choosenEmail ||
						!scope.mailDataClient.choosenEmail.id
					) {
						if (scope.mailDataClient.mailSignature) {
							scope.mailDataClient.emailText = '';
							scope.mailDataClient.emailText = `<br/><br/>${
								scope.mailDataClient.emailTextReply
							}<br/><br/>${scope.mailDataClient.mailSignature}`;
						}

						scope.attachmentsData = angular.copy(attachmentsObj);
						scope.tokenAttachmentsData = angular.copy(attachmentsObj);

						return false;
					}

					templateRequestsService
						.getTemplates('full_template', scope.mailDataClient.choosenEmail.id)
						.subscribe(emailTemplate => {
							if (emailTemplate) {
								if (
									emailTemplate.storedAttachments &&
									emailTemplate.storedAttachments.length
								) {
									scope.attachmentsData = {
										attachments: fileUploadService.convertAttachmentsToShow(
											emailTemplate.storedAttachments
										)
									};
									scope.tokenAttachmentsData = angular.copy(
										scope.attachmentsData
									);
								} else {
									scope.attachmentsData = angular.copy(attachmentsObj);
									scope.tokenAttachmentsData = angular.copy(attachmentsObj);
								}
								scope.mailDataClient.emailSubject = emailTemplate.subject || '';
								scope.mailDataClient.emailText = '';
								scope.mailDataClient.emailText = emailTemplate.text;
							}

							scope.$evalAsync();
						});
				};

				scope.toggleViewCc = function(state) {
					scope.showCcField = state === undefined ? !scope.showCcField : state;
					if (state === false) {
						attachmentsObj = {
							attachments: [],
							filesSize: 0
						};

						scope.attachmentsData = angular.copy(attachmentsObj);
						scope.tokenAttachmentsData = angular.copy(attachmentsObj);
					}
				};

				function setMailData(newValue) {
					if (newValue === undefined) {
						return;
					}
					scope.emailTemplates = angular.copy(newValue.emails);
					scope.sendMessageData = {
						emailSubject: newValue.emailSubject || '',
						emailText: newValue.emailText || '',
						emailTo: newValue.email ? [newValue.email] : [],
						emailCc: []
					};
					if (newValue.secondaryEmail && !newValue.task) {
						scope.sendMessageData.emailTo.push(newValue.secondaryEmail);
					}
					if (newValue.mailSignature && newValue.task === undefined) {
						scope.sendMessageData.emailText += `<br><br>${
							newValue.mailSignature
						}`;
					}

					if (newValue && newValue.from) {
						if (!scope.mailDataClient) {
							scope.mailDataClient = {};
						}
						scope.mailDataClient.from = newValue.from ? [newValue.from] : [];
						scope.mailDataClient.emailCc = [];
					}

					// if (isFirstShow) {
					//     isFirstShow = false;
					if (newValue.hasOwnProperty('task')) {
						const emailData = angular.copy(newValue.task.taskEmail);
						const isUserEmailChosen = isUserEmail(emailData);

						if (isUserEmailChosen) {
							scope.isUserEmail = true;
						}

						prepareEmailTemplate(newValue);
						const attachments =
							angular.copy(newValue.task.taskEmail.storedAttachments) || [];
						if (attachments.length) {
							scope.attachmentsData = {
								attachments: fileUploadService.convertAttachmentsToShow(
									attachments
								)
							};
						} else {
							clearAttachments();
						}
						scope.$evalAsync();
					} else {
						setEmptyEmailData();
					}
					// }
				}

				scope.setEmailData = (newData, object, property) => {
					scope[object][property] = newData;
				};

				scope.sendUserEmail = () => {
					if (scope.mailData.task !== undefined) {
						scope.mailData.task.taskEmail.emailTemplateId =
							scope.selectedEmailTemplate.id;
						scope.mailData.task.taskEmail.name =
							scope.selectedEmailTemplate.name;
						saveChangeTask(scope.mailData.task);
					} else {
						const maxSize = 10; // 10Mb
						if (
							scope.attachmentsData.filesSize > maxSize ||
							scope.tokenAttachmentsData.filesSize > maxSize
						) {
							messageService.showToaster('w_0', 'attachments');
							return false;
						}

						let _emailText = '';

						if (scope.sendMessageData.emailText) {
							_emailText = scope.sendMessageData.emailText;
						} else if (scope.mailDataClient.emailText) {
							_emailText = scope.mailDataClient.emailText;
						} else {
							_emailText = $('.modal.in .ql-editor').getInnerHTML();
						}

						scope.sendMessageData.emailText = $rootScope.addMaiStyling(
							_emailText
						);

						const mailData = emailService.prepareEmails(scope.sendMessageData);

						if (!emailService.validateMails(mailData)) {
							return;
						}

						scope.emailDataToSave = Object.assign(
							{},
							scope.sendMessageData,
							mailData
						);

						delete scope.emailDataToSave.emailCc;

						scope.disableBtnOnSend = true;
						let url = '';
						if ($route.current.params.leadId) {
							url = `/api/user/lead/${$route.current.params.leadId}/send/${
								scope.mailData.id
							}/`;
						} else if (
							scope.$parent.sendEmailLeadId &&
							scope.$parent.sendEmailLeadId !== null
						) {
							url = `/api/user/lead/${scope.$parent.sendEmailLeadId}/send/${
								scope.mailData.id
							}/`;
						} else {
							url = `/protected/rest/clients/send/${scope.mailData.id}/`;
							url += $route.current.params.jobId
								? $route.current.params.jobId
								: '';
						}

						scope.sendMessageData.templateId = '';
						if (scope.mailData.choosenEmail && scope.mailData.choosenEmail.id) {
							scope.sendMessageData.templateId = scope.mailData.choosenEmail.id;
						}

						const formData = new FormData();

						angular.forEach(scope.emailDataToSave, (value, key) => {
							console.debug(`key: ${key}  | value: ${value}`);
							formData.append(key, value);
						});
						let storedFiles, uploadedFiles;
						const isTokenAttachmentsData =
							$rootScope.clientToken || scope.isClientsOverview;

						if (isTokenAttachmentsData) {
							storedFiles = scope.tokenAttachmentsData.attachments.filter(
								file => file.id
							);
							uploadedFiles = scope.tokenAttachmentsData.attachments.filter(
								file => !file.id
							);
						} else {
							storedFiles = scope.attachmentsData.attachments.filter(
								file => file.id
							);
							uploadedFiles = scope.attachmentsData.attachments.filter(
								file => !file.id
							);
						}

						angular.forEach(uploadedFiles, (value, key) => {
							formData.append(`attachments[${key}]`, value);
						});

						angular.forEach(storedFiles, (value, key) => {
							formData.append(`storedAttachments[${key}]`, value.id);
						});

						mailsDataService
							.sendMailRequest(url, formData)
							.subscribe(successSendEmail, errorSendEmail);
					}
				};

				scope.sendUserEmailReply = () => {
					const maxSize = 10; // 10Mb
					if (
						scope.attachmentsData.filesSize > maxSize ||
						scope.tokenAttachmentsData.filesSize > maxSize
					) {
						messageService.showToaster('w_0', 'attachments');
						return false;
					}

					let _emailText = '';

					if (scope.sendMessageData.emailText) {
						_emailText = scope.sendMessageData.emailText;
					} else if (scope.mailDataClient.emailText) {
						_emailText = scope.mailDataClient.emailText;
					} else {
						_emailText = $('.modal.in .ql-editor').getInnerHTML();
					}

					scope.sendMessageData.emailText = $rootScope.addMaiStyling(
						_emailText
					);

					let url = '';
					if ($route.current.params.leadId) {
						url = `/api/user/lead/${$route.current.params.leadId}/send/${
							scope.mailDataClient.id
						}/`;
					} else {
						url = `/protected/rest/clients/send/${
							scope.mailDataClient.contactId
						}/`;
						url += $route.current.params.jobId
							? $route.current.params.jobId
							: '';
					}

					scope.mailDataClient.templateId = '';
					if (
						scope.mailDataClient.choosenEmail &&
						scope.mailDataClient.choosenEmail.id
					) {
						scope.mailDataClient.templateId =
							scope.mailDataClient.choosenEmail.id;
					}

					scope.mailDataClient.emailTo = scope.mailDataClient.from;
					if (scope.mailDataClient.emailCc === null) {
						delete scope.mailDataClient.emailCc;
					}

					const mailData = emailService.prepareEmails(scope.mailDataClient);

					if (!emailService.validateMails(mailData)) {
						return;
					}

					scope.emailDataToSaveReply = Object.assign(
						{},
						scope.mailDataClient,
						mailData
					);

					delete scope.emailDataToSaveReply.emailCc;

					// sendMessageData

					const formData = new FormData();

					angular.forEach(scope.emailDataToSaveReply, (value, key) => {
						console.debug(`key: ${key}  | value: ${value}`);
						formData.append(key, value);
					});
					let storedFiles, uploadedFiles;
					const isTokenAttachmentsData =
						$rootScope.clientToken || scope.isClientsOverview;

					if (isTokenAttachmentsData) {
						storedFiles = scope.tokenAttachmentsData.attachments.filter(
							file => file.id
						);
						uploadedFiles = scope.tokenAttachmentsData.attachments.filter(
							file => !file.id
						);
					} else {
						storedFiles = scope.attachmentsData.attachments.filter(
							file => file.id
						);
						uploadedFiles = scope.attachmentsData.attachments.filter(
							file => !file.id
						);
					}

					angular.forEach(uploadedFiles, (value, key) => {
						formData.append(`attachments[${key}]`, value);
					});

					angular.forEach(storedFiles, (value, key) => {
						formData.append(`storedAttachments[${key}]`, value.id);
					});

					scope.disableBtnOnSend = true;
					mailsDataService
						.sendMailRequest(url, formData)
						.subscribe(successSendEmail, errorSendEmail);
				};

				const handleTask = (task, taskTypes) => {
					if (task.dateItem) {
						task.dateItem = task.dateItem.toLowerCase();
					}

					if (task.due && !task.hasDue) {
						// for old workflows
						task.hasDue = true;
					}

					if (!task.action && task.taskEmail) {
						// for old workflows
						task.action = 'SEND_EMAIL';
					}

					if (task.calendarEventType === 'MAIN_SHOOT') {
						const {
							startDate,
							finishDate,
							startTime,
							finishTime,
							location
						} = $scope.job;
						task.location = location;
						task.startDate = startDate;
						task.endDate = finishDate;
						task.startTime = startTime;
						task.endTime = finishTime;
					} else if (task.calendarEvent) {
						const {
							startDate,
							endDate,
							startTime,
							endTime,
							location,
							clientId
						} = task.calendarEvent;
						task.location = location;
						task.startDate = startDate;
						task.endDate = endDate;
						task.startTime = startTime;
						task.endTime = endTime;
						task.sendEmails = clientId ? task.calendarEvent.sendEmails : false;

						if (
							task.startDate &&
							(task.startTime === null || task.finishTime === null)
						) {
							task.allday = true;
						}
					}

					task.overdueDays = workflowService.calcTaskOverdue(task.overdueDays);
					task.taskViewDue = workflowService.getTaskViewDue(task, taskTypes);
					task.taskDueDefault =
						task.defaultTask && task.dueDate ? task.dueDate : null;
				};

				const saveTaskWithAttachments = task => {
					prepareEmailAttachments(task.taskEmail).then(
						result => {
							task.taskEmail = result;
							saveChangeTask(task);
						},
						error => {
							scope.button_disabled = false;
						}
					);
				};

				const prepareEmailAttachments = taskEmail => {
					const deferred = $q.defer();
					taskEmail.attachmentsData = scope.attachmentsData;
					const isAttachments =
						taskEmail.attachmentsData &&
						taskEmail.attachmentsData.attachments.length;

					if (!isAttachments) {
						deferred.resolve(taskEmail);
						return deferred.promise;
					}

					const { attachments, filesSize } = taskEmail.attachmentsData;
					const maxSize = 10; // 10Mb

					if (filesSize > maxSize) {
						messageService.showToaster('w_0', 'attachments');
						deferred.reject('Attachments size exceeds the limit');
						return deferred.promise;
					}

					let uploadedAttachments, storedAttachments;

					if (attachments.length) {
						uploadedAttachments = attachments.filter(
							attachment => !attachment.id
						);
						scope.storedAttachmentsForMail = attachments.filter(
							attachment => attachment.id
						);
					}

					taskEmail.storedAttachments =
						storedAttachments && storedAttachments.length
							? storedAttachments
							: null;

					if (uploadedAttachments && uploadedAttachments.length) {
						fileUploadService
							.convertFileToSave(uploadedAttachments)
							.then(convertedFilesArr => {
								scope.base64AttachmentsForMail = convertedFilesArr;
								deferred.resolve(taskEmail);
							})
							.catch(error => console.log(error));
					} else {
						deferred.resolve(taskEmail);
					}

					delete taskEmail.attachmentsData;
					return deferred.promise;
				};

				function saveChangeTask(task) {
					scope.disableBtnOnSend = true;
					task.jobId = scope.mailData.jobId;
					if (
						scope.mailData.choosenEmail !== undefined &&
						scope.mailData.choosenEmail !== null
					) {
						task.taskEmail.emailTemplateId = scope.mailData.choosenEmail.id;
					}
					if (task.overdueDays !== null) {
						if (typeof task.overdueDays === 'string') {
							task.overdueDays = parseInt(task.overdueDays.match(/\d+/)[0], 10);
						}
					}
					task.taskEmail.subject = scope.sendMessageData.emailSubject;
					task.taskEmail.text = scope.sendMessageData.emailText;
					task.taskEmail.storedAttachments = null;
					task.taskEmail.base64Attachments = null;
					scope.uploadedAttachments = null;
					if (
						scope.attachmentsData.attachments &&
						scope.attachmentsData.attachments.length !== 0
					) {
						task.taskEmail.storedAttachments = scope.attachmentsData.attachments.filter(
							attachment => attachment.id
						);
						scope.uploadedAttachments = scope.attachmentsData.attachments.filter(
							attachment => !attachment.id
						);
					}

					if (scope.uploadedAttachments && scope.uploadedAttachments.length) {
						fileUploadService
							.convertFileToSave(scope.uploadedAttachments)
							.then(convertedFilesArr => {
								task.taskEmail.base64Attachments = convertedFilesArr;
								workflowDataService
									.saveTask(task)
									.subscribe(
										data => changeTaskState(data.tasks[data.taskToAnimate]),
										error => errorSaveTask(error.data)
									);
							})
							.catch(error => console.log(error));
					} else {
						workflowDataService
							.saveTask(task)
							.subscribe(
								data => changeTaskState(data.tasks[data.taskToAnimate]),
								error => errorSaveTask(error)
							);
					}
				}

				function errorSaveTask(data) {
					scope.isSentSpinnningWheelActive = false;
					scope.disableBtnOnSend = false;
					workflowService.errorSaveTask(data);
				}

				function changeTaskState(task) {
					task.completed = true;
					newJobsDataService
						.changeTaskState(scope.mailData.jobId, task)
						.finally(() => {
							$rootScope.dnd.canMove = true;
							scope.disableBtnOnSend = false;
						})
						.subscribe(
							data => {
								toastr.clear();
								task = Object.assign(task, data);
								handleTask(task, scope.mailData.sortedTasksArr);
								isFirstShow = true;
								messageService.showToaster('s_4', 'clients');
								$('#sendContactEmailModal').modal('hide');
								messageService.showToaster('i_0', 'jobView');
								if (scope.isLeadPage) {
									$rootScope.updateLeadView();
								} else if (scope.isJobPage) {
									$rootScope.updateJobView();
								}
							},
							result => {
								toastr.clear();
								const { error } = result;
								if (error) {
									const { errorMessage, errorTitle } = error;
									messageService.showErrorFromBackend(errorTitle, errorMessage);
									return;
								}
								messageService.showDefaultErrorMessage(result);
							}
						);
				}

				function successSendEmail() {
					scope.disableBtnOnSend = false;
					scope.$evalAsync();
					isFirstShow = true;
					messageService.showToaster('s_4', 'clients');

					$('#sendContactEmailModal').modal('hide');

					if (scope.updateParent) {
						return scope.updateParent({ resetPagination: false });
					}

					if (scope.isLeadPage && $rootScope.updateLeadView) {
						if (scope.mailData.task !== undefined) {
							// changeTaskState(scope.mailData.task);
						} else {
							$rootScope.updateLeadView();
						}
					}

					if (scope.isJobPage && $rootScope.updateJobView) {
						if (scope.mailData.task !== undefined) {
							// changeTaskState(scope.mailData.task);
						} else {
							$rootScope.updateJobView();
						}
					}
					if (
						$rootScope.updateClientView &&
						$location.path().includes('/clients/')
					) {
						$rootScope.updateClientView();
					}
					scope.disableBtnOnSend = false;
					scope.showCcField = false;

					for (const prop in scope.sendMessageData) {
						scope.sendMessageData[prop] = '';
					}

					delete scope.attachmentsData;
					delete scope.uploadedAttachments;
					scope.tokenAttachmentsData.attachments.length = 0;
					scope.$evalAsync();
				}

				function errorSendEmail({ status, data, error }) {
					isFirstShow = false;
					scope.disableBtnOnSend = false;
					const { errorMessage, errorTitle } = error;

					const path = $location.path();
					const isClientsOverview = path.includes('clients');
					if (status >= 400 && status < 500 && data.errorMessage) {
						if (status === 423) {
							const limit = $rootScope.isUserTrial ? 50 : 150;
							return messageService.showToaster(
								'e_4',
								'generalValidation',
								limit
							);
						} else if (data.errorMessage.includes('Email address inactive')) {
							messageService.showToaster(
								'e_1',
								'generalValidation',
								scope.sendMessageData.emailTo
							);
						} else if (data.errorMessage.includes('Lead is archived')) {
							messageService.showToaster('e_5', 'lead');
						} else if (
							isClientsOverview &&
							data.errorMessage.includes('job-related variables')
						) {
							messageService.showToaster('e_7', 'clients');
						} else if (errorTitle) {
							messageService.showErrorFromBackend(errorTitle, errorMessage);
						} else {
							messageService.showToaster('e_2', 'general', errorMessage);
						}
					} else {
						messageService.showToaster('e_0', 'general');
					}
				}

				function getJobTypes() {
					return jobTypesDataService
						.getJobTypes()
						.map(data => successGetJobTypes(data));
				}

				function successGetJobTypes(data) {
					scope.newJob.jobTypes = angular.copy(data);
				}

				function getWorkflowNames() {
					return workflowDataService
						.getWorkflowNames()
						.map(data => successGetWorkflowNames(data));
				}

				function successGetWorkflowNames(data) {
					if (!data) {
						return false;
					}
					scope.newJob.workflowNames = angular.copy(data);
				}

				function showNewJobModal(event) {
					const selectModal = '#sendContactEmailModal',
						nextModal = '#newJob';
					scope.$broadcast('showModalJob', scope.newJob);
					utilsService.showNextModal(selectModal, nextModal, event);
				}

				scope.addNewJob = event => {
					scope.newJob = {};
					scope.clients = [];
					const primaryClientSearchText = jobDataService.fillClientSearchText(
						scope.mailData
					);
					scope.clients[0] = primaryClientSearchText;
					scope.newJob.primaryContact = scope.clients[0];
					scope.workflowNames = [];

					Rx.Observable.zip(getJobTypes(), getWorkflowNames())
						// .takeUntil($scope.unsubscribe)
						.subscribe(() => showNewJobModal(event));
				};

				scope.disableDragDrop = () => true;

				$('#sendContactEmailModal')
					.on('show.bs.modal', () => {
						scope.$broadcast('addedFileEvent');
						$('#sendContactEmailModal')
							.find('input')
							.prop('autocomplete', 'off');

						if (
							typeof scope.mailDataClient === 'undefined' ||
							scope.mailDataClient === null ||
							!scope.mailDataClient.hasOwnProperty('emailText')
						) {
							scope.mailDataClient = {};
						} else if (
							scope.mailDataClient.emailText === '' ||
							scope.mailDataClient.emailText === '<p></p>'
						) {
							scope.mailDataClient.emailText = `<br><br>${
								scope.mailDataClient.emailTextReply
							}<br>`;

							if (scope.mailDataClient.subject.indexOf('RE:') !== -1) {
								scope.mailDataClient.subject = `RE: ${
									scope.mailDataClient.subject
								}`;
							}
						}
					})
					.on('shown.bs.modal', () => {
						const input = $('input');
						const select = $('select');

						validationService.isModalClosePrevented(input);
						validationService.isModalClosePrevented(select);
					});
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Modals/private/modalSendMail.js